import React from 'react';
import { getQueryHashKey } from '../../apis-infra';
import { useIsFetching } from 'react-query';
import { getQueryFilter } from './queryFilters';
import { getSharedQueryClient } from './queryClientInstance';
import { toCachedQuery } from './cacheOperations';
export function useIsApiFetching() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  const pred = React.useMemo(() => getQueryFilter(...args), [...args]);
  return useIsFetching({
    predicate: pred
  });
}
export function useUpdatedQueries(filters) {
  const [stats, setStats] = React.useState({});
  const pred = React.useMemo(() => getQueryFilter(filters), [filters]);
  const mountRef = React.useRef(false);
  React.useEffect(() => {
    mountRef.current = true;
    return () => {
      mountRef.current = false;
    };
  });
  React.useEffect(() => {
    const queryClient = getSharedQueryClient();
    const unsubscribe = queryClient.getQueryCache().subscribe(evt => {
      if (evt != null && evt.query && ((evt == null ? void 0 : evt.type) === 'queryUpdated' || (evt == null ? void 0 : evt.type) === 'queryRemoved')) {
        const hashKey = getQueryHashKey(evt.query.queryKey);
        const hasQuery = stats[hashKey];
        const passedFilters = pred(evt.query);
        if (!passedFilters && hasQuery) {
          setStats(_ref => {
            let {
              [hashKey]: toRemove,
              ...rest
            } = _ref;
            return {
              ...rest
            };
          });
        } else if (passedFilters) {
          setStats(prev => ({
            ...prev,
            [hashKey]: toCachedQuery(evt.query)
          }));
        }
      }
    });
    return () => {
      if (mountRef.current) {
        unsubscribe();
      }
    };
  }, [pred]);
  return React.useMemo(() => Object.values(stats), [stats]);
}
//# sourceMappingURL=useIsApiFetching.js.map